import React, { Component } from "react";
import TournamentCardComponent from "../../Tournaments/TournamentCardComponent";
import loadinggif from "../../../assets/images/loading.gif";
import NotFoundContainer from "../../../containers/NotFoundContainer";

class HostChallengesUpcomingViewAllComponent extends Component {
  componentDidMount() {
    this.props.invalidateBrandDetails();
    this.props.fetchBrandDetailsIfNeeded({
      brandId: this.props.match.params.id,
      profileId: this.props.userId
    });

    const {
      fetchHostChallengesUpcomingViewAllIfNeeded,
      invalidateAllHostChallengesUpcomingViewAll,
      page
    } = this.props;
    invalidateAllHostChallengesUpcomingViewAll();
    fetchHostChallengesUpcomingViewAllIfNeeded({
      // profileId: this.props.userId,
      brandId: this.props.match.params.id,
      page: page
    });
  }

  componentDidUpdate() {
    document.body.classList.remove("modal-open");
  }

  render() {
    const { hostChallengesUpcomingList, brandDetails, page } = this.props;

    if (hostChallengesUpcomingList.isFetching) {
      return (
        <div className="text-center">
          <div className="col-sm-12">
            <img src={loadinggif} alt="" />
          </div>
        </div>
      );
    }
    // if (!(hostChallengesUpcomingList.items.length > 0)) {
    //   return <NotFoundContainer />;
    // }

    if (
      hostChallengesUpcomingList &&
      brandDetails &&
      brandDetails.item &&
      hostChallengesUpcomingList.items
    ) {
      return (
        <section className="container-fluid my-tournament-wrapper">
          <div className="row">
            <div className="container">
              <div className="padder-main">
                <div className="row d-flex align-items-center mb-30 ">
                  <div className="col-8 d-flex justify-content-start">
                    <h2 className="bold">
                      {brandDetails.item.name}'s Tournaments
                    </h2>
                  </div>
                </div>

                <div className="row card-wrapper d-flex justify-content-center justify-content-sm-start">
                  {this.props.hostChallengesUpcomingList.items.length > 0
                    ? this.props.hostChallengesUpcomingList.items.map(
                        (tournament, i) => (
                          <div className="col-auto mb-4" key={i}>
                            <TournamentCardComponent
                              {...tournament}
                              cardClass="card card-my-tournament"
                              brandAvatarClass="profile-pic-56"
                              challengeType="Upcoming"
                              order={i+1}
                            />
                          </div>
                        )
                      )
                    : ""}
                </div>
                <div className="row mb-30 text-center">
                  <div className="col-sm-12">
                    {this.props.hostChallengesUpcomingList.items.length > 0 ? (
                      !this.props.hostChallengesUpcomingList.isLastPage ? (
                        <button
                          onClick={() => {
                            this.props.invalidateHostChallengesUpcomingViewAll();
                            this.props.fetchHostChallengesUpcomingViewAllIfNeeded(
                              {
                                //profileId: this.props.userId,
                                brandId: this.props.match.params.id,
                                page: page
                              }
                            );
                          }}
                          className="btn btn-pink dark btn-xs"
                        >
                          Load More
                        </button>
                      ) : this.props.hostChallengesUpcomingList.isFetching ? (
                        <img src={loadinggif} alt="" />
                      ) : (
                        ""
                      )
                    ) : this.props.hostChallengesUpcomingList.isFetching ? (
                      <img className="text-center" src={loadinggif} alt="" />
                    ) : (
                      <span>No Tournament Found</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return <></>;
    }
  }
}

export default HostChallengesUpcomingViewAllComponent;
